import { AuthApi } from '@/services';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes';
const TRACKING_ID = !process.env.REACT_APP_GTAG_TRACKING_ID
    ? '__GTAG_TRACKING_ID__'
    : process.env.REACT_APP_GTAG_TRACKING_ID;
ReactGA.initialize(TRACKING_ID);
const App = () => {
    const BASE_URL = (window.env && window.env.BASE_URL !== '__API_URL__' && window.env.BASE_URL) ||
        process.env.REACT_APP_BASE_URL ||
        '/';
    useEffect(() => {
        AuthApi.createSession().catch();
    }, []);
    return (React.createElement(BrowserRouter, { basename: BASE_URL, future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        } },
        React.createElement(AppRoutes, null)));
};
export default App;
